export const OperatorHasAny = 'has any of';
export const OperatorHasAll = 'has all of';
export const OperatorNot = 'is not';
export const OperatorEquals = 'equals';
export const OperatorFreeformEquals = 'freeformEquals';
export const OperatorNotEquals = 'not equals';
export const OperatorSentimentNegative = 'negative';
export const OperatorSentimentPositive = 'positive';
export const OperatorSentimentNeutral = 'neutral';
export const OperatorFor = 'for';
export const OperatorForAnyOf = 'for any of';
export const OperatorForAllOf = 'for all of';
export const OperatorExcludeAnyOf = 'excluding any of';
export const OperatorExcludeAllOf = 'excluding all of';
export const OperatorExactlyAnyOf = 'exactly matches any of';
export const OperatorExactlyAllOf = 'exactly matches all of';
export const OperatorIsPresent = 'is present';
export const OperatorIsNotPresent = 'is not present';
export const OperatorEqualsSingle = 'equals single';
export const OperatorNotEqualsSingle = 'not equals single';
export const OperatorIsGreaterThan = 'is greater than';
export const OperatorIsLessThan = 'is less than';
export const OperatorIsAnyOf = 'is any of';
export const OperatorIsAllOf = 'is all of';
export const OperatorIsNotAnyOf = 'is not any of';
export const OperatorContainsAnyOf = 'contains any of';
